var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('tr',{staticClass:"loading-row"},[_c('td',{attrs:{"colspan":_vm.colspan}},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#6ec39b","height":"3"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }